'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { cn } from '@/lib/utils'

const TABS = [
  { label: 'Home', href: '/fpl', end: true },
  { label: 'Users', href: '/fpl/users', end: false },
  { label: 'Players', href: '/fpl/players', end: false },
  { label: 'Leagues', href: '/fpl/leagues', end: false },
  { label: 'Compare', href: '/fpl/compare', end: false },
] as const

// react-router's <NavLink> computes isActive for us (respecting `end`);
// Next has no equivalent, so replicate the same matching against the
// current pathname here.
function isTabActive(pathname: string, href: string, end: boolean) {
  if (end) return pathname === href
  return pathname === href || pathname.startsWith(`${href}/`)
}

export function FplTabs() {
  const pathname = usePathname()

  return (
    <div className="flex items-center gap-1 border-b border-white/10 px-4 sm:px-0">
      {TABS.map((t) => {
        const active = isTabActive(pathname, t.href, t.end)
        return (
          <Link
            key={t.label}
            href={t.href}
            className={cn(
              'border-b-2 px-3 py-2 text-sm font-medium transition-colors no-underline',
              active ? 'border-white text-white' : 'border-transparent text-white/50 hover:text-white/80'
            )}
          >
            {t.label}
          </Link>
        )
      })}
    </div>
  )
}
